module.exports = __webpack_public_path__ + "img/central-klaus.21fb49a7.svg";